<script lang="ts" module>
	export interface CircularProgressProps {
		dataCy: string;
		color?: 'dark' | 'light' | undefined;
		class?: string;
		title?: string;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';

	let { dataCy, color = 'dark', ...rest }: CircularProgressProps = $props();
</script>

<div
	data-cy={`${dataCy}-circular-progress`}
	title={rest.title}
	class={twMerge(
		classNames('animate-spin h-[16px] w-[16px] border rounded-full', {
			'border-gray-500 border-t-transparent': color === 'dark',
			'border-gray-0 border-t-transparent': color === 'light'
		}),
		rest.class
	)}
></div>
